import { Box, Typography } from '@mui/material';
import i18n from '../../../i18n';
import { ReactComponent as WarningIcon } from '../../../static/images/svg/jam_triangle-danger-f.svg';

/** 单条风控项：i18n key + 数量 */
export type RiskItem = { labelKey: string; count: number };

const LIST_BORDER_STYLE = {
    '& > *:not(:last-child)': {
        borderBottom: '1px solid var(--stroke-neutral-800-a25)',
        paddingBottom: '8px',
        marginBottom: '8px',
    },
};

const BADGE_STYLE = {
    bgcolor: 'var(--func-error)',
    color: '#fff',
    borderRadius: '50%',
    minWidth: 28,
    height: 28,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    typography: 'body2',
    fontWeight: 700,
} as const;

/**
 * 餐厅风控区块
 * 展示风控项列表，每行：警示图标 + 文案 + 红色数字徽章
 */
export default function RestaurantRiskSection(props: Readonly<{ items: RiskItem[] }>) {
    const { items } = props;
    return (
        <>
            <Typography variant="h4" sx={{ color: 'var(--text-primary-300)', textAlign: 'center' }}>
                {i18n.t('intelligent_risk_control_page_text_restaurant_risk_control')}
            </Typography>
            <Box sx={LIST_BORDER_STYLE}>
                {items.map(({ labelKey, count }) => (
                    <Box
                        key={labelKey}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        flexWrap="wrap"
                    >
                        <Box display="flex" alignItems="center" gap="0.5rem">
                            <WarningIcon height="24px" color="var(--func-error, #d32f2f)" />
                            <Typography variant="body1">{i18n.t(labelKey)}</Typography>
                        </Box>
                        <Box component="span" sx={BADGE_STYLE}>
                            {/* 超过 99 时统一显示 99+，避免数字过长撑破布局 */}
                            {count > 99 ? '99+' : count}
                        </Box>
                    </Box>
                ))}
            </Box>
        </>
    );
}
